"use strict";

var _ = require("underscore");
var cx = require("classnames");
var moment = require("moment");
var FormatUrl = require("app/util/formatter/url");
var UserAvatar = require("app/shared/components/User/user-avatar");
var ActivityOwner = require("../ActivityInput/activity-owner");
var MetricType = require("../Metric/metric-type.jsx");
var MetricsContainer = require("../Metric/metrics-container.jsx");
var Icon = require("app/shared/components/Icon/icon");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var text = require("app/util/formatter/text");
moment.locale("pt-br");

/*
 ## External Dependencies ##
  - jQuery ($)
  - $.tooltip
  - $.datepicker
  - $.colorbox-min.js
 */

var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var Prompt = require("app/shared/components/Prompt/prompt");
var DatetimePicker = require("../ActivityInput/datetime-picker.jsx");
var Popover = require("app/shared/components/Popover/popover");
var MultiActionStore = require("app/util/flux/multi-action-store");

var Activity = React.createClass({
  propTypes: {
    permissions: React.PropTypes.object.isRequired
  },
  render: function() {
    return (
      <div className="activity">
        <div className="activity-header">
          <div>
            <ActivityType {...this.props} />
          </div>
          <div>
            <ActivityDueDate dueDate={this.props.due_date} timezone={this.props.timezone} activityId={this.props.id} createdBy={this.props.created_by} done={(this.props.finished_date!=null)?true:false} canReschedule={this.props.permissions.reschedule} />
            {
              this.props.utc_finished_date && this.props.finished_by &&
              <ActivityFinishedBy
                user={this.props.finished_by}
                dateUtc={this.props.utc_finished_date}
              />
            }
            <ActivityButtonFinish
              activityId={this.props.id}
              createdBy={this.props.created_by}
              finishedBy={this.props.finished_by}
              timezone={this.props.timezone}
              finishedDateUtc={this.props.utc_finished_date}
              canFinish={this.props.permissions.finish}
              dueDate={this.props.due_date}
              done={(this.props.finished_date!=null)?true:false}
              filters={this.props.filters} />
            <ActivityButtonEdit {...this.props} canEdit={this.props.permissions.edit} />
            <ActivityButtonRemove ref="remove-button" activityId={this.props.id} canDelete={this.props.permissions.delete} />
          </div>
        </div>
        <div className="activity-body">
          <div className="activity-info">
            <div className="d-f align-center minw-150">
              <ActivityOwner dropbox={this.props.dropbox} createdBy={this.props.created_by}>
                <ActivityCreationDate creationDate={this.props.creation_date} timezone={this.props.timezone} />
              </ActivityOwner>
            </div>

            <ActivityAssignedUsers assignedUsers={this.props.assigned_users} createdBy={this.props.created_by} activityId={this.props.id} />

            <ActivityRelatedObjects {...this.props} />
          </div>

          <ActivityEmailInfo dropbox={this.props.dropbox} />

          <ActivityText text={this.props.text} />
          <ActivityMetricsContainer metrics={this.props.metrics} />
          <ActivityImages images={this.props.images} />
          <ActivityDocs documents={this.props.documents} />
        </div>
      </div>
    );
  }
});

var ActivityMetricsContainer = React.createClass({
  render: function(){
    var metrics = [];

    if (this.props.metrics.length  > 0) {
      for (var key in this.props.metrics) {
        var metric = this.props.metrics[key];
        if (!metric.metric_type) {
          metric.removable = false;
          metrics.push(metric);
        }
      }
    }

    return (
      <MetricsContainer className="activity-metrics" metrics={metrics} />
    );
  }
});

var ActivityType = React.createClass({
  render: function(){
    var considerActivityFinished = (Boolean(this.props.finished_date) || !this.props.due_date);
    var activityDoneBy = this.props.created_by.type;
    var label;
    var icon;

    if (this.props.due_date) {
      label = "Tarefa";
      icon = "task";
    } else {
      label = "Nota";
      icon = "note";
    }

    if (this.props.activityType) {
      label = MetricType.getLabel(
        this.props.activityType.metric_type,
        considerActivityFinished,
        activityDoneBy
      );
      icon = MetricType.getIconClass(this.props.activityType.metric_type);
    }

    return (
      <div className="u-flex-center">
        <Icon custom icon={icon} />
        <label className="activity-typeLabel">{label}</label>
      </div>
    );
  }
});

var ActivityEmailInfo = React.createClass({
  getInitialState: function(){
    return {
      showDetails: false
    };
  },
  showDetails: function(e){
    this.setState({showDetails: true});
  },
  render: function(){
    return (this.props.dropbox)?(
      <div className="js-activity-emailInfo activity-info mt-10">
        <ul className="mb-0 lh-21">
          <li>
            Assunto:<span className="ml-5 c-lightGrey">{this.props.dropbox.subject}</span>
            {(!this.state.showDetails)?<a href="javascript:void(0);" className="ml-10" onClick={this.showDetails}>Ver detalhes</a>:null}
          </li>
          {(this.props.dropbox.from&&this.state.showDetails)?<li>De:<span className="ml-5 c-lightGrey">{this.props.dropbox.from}</span></li>:null}
          {(this.props.dropbox.to&&this.state.showDetails)?<li>Para:<span className="ml-5 c-lightGrey">{this.props.dropbox.to}</span></li>:null}
          {(this.props.dropbox.cc&&this.state.showDetails)?<li>Cc:<span className="ml-5 c-lightGrey">{this.props.dropbox.cc}</span></li>:null}
        </ul>
      </div>
    ):null;
  }
});

var ActivityText = React.createClass({
  getInitialState: function(){
    return {
      hasLongText: false,
      isTextTruncated: false,
      showAnimation: false // necessary to just shown animation after viewMore button is clicked
    };
  },
  componentDidMount: function(){
    var textHeight = $(this.refs["text"]).outerHeight();
    this.setState({textHeight: textHeight});
    if(textHeight >= 200) {
      this.setState({
        hasLongText: true,
        isTextTruncated: true
      });
    }
  },
  showMoreText: function(){
    this.setState({
      isTextTruncated: !this.state.isTextTruncated,
      showAnimation: true
    });
  },
  getViewMoreButtonText: function () {
    if (this.state.isTextTruncated) {
      return "Ver mais";
    } else {
      return "Ver menos";
    }
  },
  escapeHtml: function(text) {
    return text
      .replace(/<br\s?\/?>/g, "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/"/g, "&#039;")
      .replace(/\n/g, "<br>");
  },
  render: function(){
    var text = this.escapeHtml(this.props.text);
    text = FormatUrl.linkify(text);

    var classesText;
    classesText = cx({
      "activity-text": true,
      "ovy-hidden": true,
      "max-height-animate": this.state.showAnimation
    });
    var styles = {};
    if (this.state.hasLongText && this.state.isTextTruncated) {
      styles["maxHeight"] = "200px";
    } else {
      styles["maxHeight"] = this.state.textHeight;
    }

    return (
      <div>
        <div className={classesText} style={styles} ref="text">
          <div dangerouslySetInnerHTML={{__html: text}} />
          {(this.state.hasLongText && this.state.isTextTruncated)? <div className="activity-textFadeOut" ref="textFadeOut"></div>:null}
        </div>
        {(this.state.hasLongText)?<a className="d-b ta-c mt-5" ref="showMoreLink" href="javascript:void(0);" onClick={this.showMoreText}>{this.getViewMoreButtonText()}</a>:null}
      </div>
    );
  }
});

function generateTooltipHTML(classes){
  return (
    "<div class='tooltip '+classes+'' role='tooltip'>"+
    "<div class='tooltip-arrow'></div>"+
    "<div class='tooltip-inner'></div>"+
    "</div>"
  );
};

var ActivityButtonRemove = React.createClass({
  componentDidMount: function(){
    var tooltipProps = { delay: {show:300, hide:0} };
    if(!this.props.canDelete) {
      tooltipProps.template = generateTooltipHTML("warning");
    }
    $(ReactDOM.findDOMNode(this)).tooltip(tooltipProps);
  },
  onConfirm: function () {
    ActivitiesListingActions.removeActivity(this.props.activityId);
  },
  render: function(){
    var classes = cx("btn", "selected", "btn-icon", "btn-filter",
      "custom-glyphicon", "icon-remove", ((!this.props.canDelete)?"disabled":""));

    var title = (!this.props.canDelete)?"Você não tem permissão para excluir esta atividade.":"Excluir";

    return (
      <span className="d-ib" title={title}>
        <PromptConfirmButtonGroup className="d-ib">
          <Prompt text="Deseja excluir este comentário?" buttonText="Excluir"
                  buttonClasses="btn btn-danger" type="confirm" onConfirm={this.onConfirm} />
          <button className={classes} disabled={!this.props.canDelete}></button>
        </PromptConfirmButtonGroup>
      </span>
    );
  }
});

var ActivityButtonEdit = React.createClass({
  componentDidMount: function(){
    var tooltipProps = { delay: {show:300, hide:0} };
    if(!this.props.canEdit) {
      tooltipProps.template = generateTooltipHTML("warning");
    }
    $(ReactDOM.findDOMNode(this)).tooltip(tooltipProps);
  },
  onClick: function(){
    var instanceKey = "activityEdit"+this.props.id;
    ActivitiesListingActions.editActivity(this.props, instanceKey);
  },
  render: function(){
    var classes = cx("btn", "selected", "btn-icon", "btn-filter",
      "custom-glyphicon", "icon-pencil", "mr-10",
      ((!this.props.canEdit)?"disabled":""));

    var title = "Editar";
    if (!this.props.canEdit) {
      title = "Você não possui privilégios para editar um comentário ou tarefa. Contate o administrador de sua conta para lhe conceder este privilégio em Grupos";
    }

    return (
      <div className="d-ib" title={title}>
        <a href="javascript:void(0);"
          onClick={(this.props.canEdit)?this.onClick:null}
          className={classes}
        />
      </div>
    );
  }
});

var ActivityCreationDate = React.createClass({
  componentDidMount: function(){
    $(ReactDOM.findDOMNode(this)).tooltip({delay: {show:300, hide:0}});
  },
  getDateFormat: function(date) {
    var today = moment().startOf("day");
    var diff = today.diff(date.clone().startOf("day"), "days", false);
    var isCloseDate = (diff == -1 || diff == 1 || diff == 0);

    if (isCloseDate) {
      return date.calendar();
    } else if (date.isSame(today, "year")) {
      return date.format("DD/MM/YYYY [às] LT");
    } else {
      return date.format("DD/MM/YYYY [às] LT");
    }
  },
  render: function(){
    var creationDate = null;
    var creationDateShort = null;

    if(this.props.creationDate){
      var dateInUserTzId = text.dateToTimezone(this.props.creationDate, "UTC", window.loggedUserTzId);
      creationDate = dateInUserTzId.format("LLLL");
      creationDateShort = this.getDateFormat(dateInUserTzId.clone());
    }

    return (creationDate)?(
      <div className="activity-createdAt" title={creationDate}>{creationDateShort}</div>
    ):null;
  }
});

var ActivityDueDate = React.createClass({
  componentDidMount: function(){
    if(this.props.dueDate){
      var dueDateFormats = this.getDueDateFormats(this.props.dueDate);
      this.applyTooltip(dueDateFormats.complete);
    }
  },
  onSelectDatetime: function(date, time){
    var newDueDate = null;
    if(date!=null){
      newDueDate = date+" "+time;
      var newDueDateFormats = this.getDueDateFormats(newDueDate);
      this.applyTooltip(newDueDateFormats.complete);
    }
    ActivitiesListingActions.rescheduleActivity(this.props.activityId, newDueDate, this.props.dueDate, window.loggedUserTzId, this.props.timezone);
  },
  applyTooltip: function(title, alertPermission){
    var container = $(this.refs["dueDateLink"]).parents(".activity");

    $(this.refs["dueDateLink"])
      .attr("title", title)
      .tooltip({container: container, delay: {show:300, hide:0} })
      .tooltip("fixTitle");

    if(alertPermission){
      $(this.refs["dueDateLink"]).tooltip("show");
      $(container).find(".tooltip").addClass("warning");
    }
  },
  alertPermission: function(e){
    this.applyTooltip("Você não tem permissão para alterar o agendamento desta tarefa.", true);
  },
  getDueDateFormats: function(dueDate){
    var normal = null;
    var fromNow = null;
    var complete = null;
    var time = null;
    var daysDiff = 1;
    var diff = null;
    var date = null;
    var userDueDate = null;

    if(dueDate!=null){
      time = moment(dueDate).format("HH:mm:ss");

      if (time != "23:59:59") {
        userDueDate = text.dateToTimezone(dueDate, this.props.timezone, window.loggedUserTzId);
        time = userDueDate.format("HH:mm:ss");
      } else {
        userDueDate = moment(dueDate);
      }
      date = userDueDate.format("YYYY-MM-DD");
      var today = moment().startOf("day");
      diff = today.diff(userDueDate.clone().startOf("day"), "days", false);
      var isCloseDate = (diff==-daysDiff||diff==daysDiff||diff==0);

      if(time=="23:59:59"){
        complete = userDueDate.format("dddd, DD [de] MMMM [de] YYYY");

        if (isCloseDate) {
          normal = userDueDate.calendar().split(" ")[0];
        } else {
          normal = userDueDate.format("DD/MMM");
        }

      } else {
        complete = userDueDate.format("LLLL");

        if (isCloseDate) {
          normal = userDueDate.calendar();
        } else {
          normal = userDueDate.format("DD/MMM [às] HH:mm");
        }
      }

      fromNow = (!this.props.done && !isCloseDate )?userDueDate.fromNow():null;
    }

    return {
      normal: normal,
      fromNow: fromNow,
      complete: complete,
      time: time,
      date: date
    };
  },
  render: function(){

    var classesDueDateLink = cx({
      "activity-dueDateLink": true,
      "activity-link": (this.props.canReschedule),
      "ml-5": true,
      "schedule-trigger": true,
      "td-lt": (this.props.done)
    });

    var schedule = null;
    var dueDateFormats = this.getDueDateFormats(this.props.dueDate);

    if(dueDateFormats.normal) {
      if(this.props.canReschedule) {

        var datetimePickerProps = {
          dueDate: `${dueDateFormats.date} ${dueDateFormats.time}`,
          afterClose: this.onSelectDatetime,
          closeAfterSetValidDatetime: false,
          closeOnEnterPress: true,
          closeOnClickDate: true
        };

        var datetimePickerTrigger = <a className={classesDueDateLink} ref="dueDateLink" href="javascript:void(0);">{dueDateFormats.normal}</a>;
        schedule = <Popover wrapperClasses="d-ib p-r" classes="p-0" trigger={datetimePickerTrigger}><DatetimePicker {...datetimePickerProps} /></Popover>;

      } else {
        schedule = <span onClick={this.alertPermission} className={classesDueDateLink} ref="dueDateLink" href="javascript:void(0);">{dueDateFormats.normal}</span>;
      }
    }

    return (this.props.dueDate)?(
      <span className="activity-dueDate">
        Prazo: {schedule}
        {(dueDateFormats.fromNow)?<span className="ml-5 c-lightGrey fst-italic">{" ("+dueDateFormats.fromNow+")"}</span>:null}
      </span>
    ):null;
  }
});

var ActivityImages = React.createClass({
  componentDidMount: function(){
    $(ReactDOM.findDOMNode(this)).find(".activity-image").colorbox({
      speed: 200,
      opacity: 0.7,
      maxWidth: "70%",
      preloading: true,
      current: "Imagem {current} de {total}",
      previous: "Anterior",
      next: "Próxima",
      close: "Fechar"
    });
  },

  render: function(){
    var images = [];

    if (this.props.images.length  > 0) {
      for (var key in this.props.images) {
        var image = this.props.images[key];

        images.push(<ActivityImage image={image} />);
      }
      images = (<div className="activity-images">{images}</div>);
    } else {
      images = null;
    }

    return images;
  }
});

var ActivityImage = React.createClass({
  getInitialState: function () {
    return { imageLocation: "" }
  },
  getImageLocation: function(imageUrl, cbf) {
    $.ajax({
       url: imageUrl,
       beforeSend: function(request) {
         request.setRequestHeader('Accept','application/json; charset=utf-8');
       },
       xhrFields: {
          withCredentials: true
       },
       success: cbf
    });
  },
  componentDidMount: function() {
    this.getImageLocation(this.props.image.url, this.setImageLocation)
  },
  setImageLocation: function(imageLocation) {
    this.setState({imageLocation: imageLocation.url});
  },
  render: function() {
    return <a className="activity-image" key={this.props.image.id}
      href={this.state.imageLocation}
      rel="activity-image"><img src={this.props.image.thumb_url} /></a>
  }
});

const docTypes = {
  doc: "doc",
  pdf: "pdf",
  ppt: "ppt",
  xls: "xls",
  xlsx: "xls"
};

var ActivityDocs = React.createClass({
  render: function(){
    var documents = [];
    var classes = null;

    if(this.props.documents.length > 0) {
      for (var key in this.props.documents) {
        classes = cx({
          "activity-doc": true,
          "activity-link": true,
          "mb-5": (key < this.props.documents.length - 1)
        });
        var doc = this.props.documents[key];
        var type = docTypes[doc.type.toLowerCase()] || "generic";
        var iconSrc = "/skins/sistema/imagens/icones/icone-doc-"+type+".png";
        documents.push(
          <li className={classes} key={doc.id}>
            <a href={doc.url} target="_blank">
              <img className="activity-docIcon mr-5" src={iconSrc} />{doc.file_name.toLowerCase()}
            </a>
          </li>
        );
      }
      documents = (<ul className="activity-docs">{documents}</ul>);
    } else {
      documents = null;
    }

    return documents;
  }
});

var ActivityAssignedUsers = React.createClass({
  componentDidMount: function(){
    $(ReactDOM.findDOMNode()).find(".activity-owner").tooltip({
      delay: {show:300, hide:0}
    });
  },
  tooltip: function() {
    const userNames = _.map(this.props.assignedUsers, function(user) { return user.name; });

    if (userNames.length > 1) {
      return "Tarefa para " + userNames.slice(0, userNames.length - 1).join(", ") + " e " + userNames.slice(-1);
    } else {
      return "Tarefa para " + userNames[0];
    }
  },

  assignedUsers: function() {
    var i = 0;
    var users = [];
    var key;

    for(key in this.props.assignedUsers) {
      if (i === 3) { break; }

      const user = this.props.assignedUsers[key];
      const avatarURL = (user.avatar) ? user.avatar["70x70"] : null;

      users.push(
        <UserAvatar className="activity-owner" name={user.name} avatarURL={avatarURL} key={key} addTitle={false} />
      )

      i++;
    }

    return users;
  },

  showMore: function() {
    if (this.props.assignedUsers.length < 4) { return null; }

    return <div className="activity-owner fw-bold userAvatar">. . .</div>;
  },

  render: function(){
    var assignedUsers = [];

    var ownerUserId = (this.props.createdBy.type=="User")?this.props.createdBy.id:null;

    var hasAssignedUsers = (this.props.assignedUsers&&_.size(this.props.assignedUsers) > 0);
    var onlyActivityOwnerIsAssigned = (_.size(this.props.assignedUsers)==1&&this.props.assignedUsers[0].id==ownerUserId);

    if(hasAssignedUsers) {
      if(onlyActivityOwnerIsAssigned) {
        assignedUsers = null;
      } else {
        assignedUsers = (
          <Tooltip title={this.tooltip()}>
            <div className="activity-owners d-f">
              <div className="activity-verticalSeparator"></div>
              {this.assignedUsers()}
              {this.showMore()}
            </div>
          </Tooltip>
        );
      }
    } else {
      assignedUsers = null;
    }
    return assignedUsers;
  }
});

var ActivityFinishedBy = React.createClass({
  getName: function() {
    return this.props.user.name;
  },

  getTitle: function() {
    let dateLocal = text.dateToTimezone(this.props.dateUtc, "UTC", window.loggedUserTzId);
    return `Finalizada: ${dateLocal.calendar()} por ${this.getName()}`;
  },

  getAvatarUrl: function() {
    return this.props.user.avatar ? this.props.user.avatar["70x70"] : "";
  },

  render: function() {
    return (
      <span className="d-ib va-mid mr-10">
        <Tooltip title={this.getTitle()}>
          <UserAvatar
            className="activity-owner"
            name={this.getName()}
            avatarURL={this.getAvatarUrl()}
            addTitle={false}
          />
        </Tooltip>
      </span>
    );
  }
});

var ActivityButtonFinish = React.createClass({
  getInitialState: function(){
    return {
      done: this.props.done
    };
  },
  getTitle: function(){
    if (!this.props.canFinish) {
      return "Você não tem permissão para finalizar essa tarefa.";
    }
  },
  componentWillReceiveProps: function(nextProps){
    this.setState({
      done: nextProps.done
    });
  },
  componentDidUpdate: function(prevProps, prevState){
    if (prevState.done == false && this.state.done == true) {
      this.setState({
        shouldAnimate: true
      });
    }
  },
  componentDidMount: function(){
    if (!this.props.canFinish) {
      let tooltipProps = { delay: {show:300, hide:0} };

      $(ReactDOM.findDOMNode(this)).tooltip(tooltipProps);
    }
  },
  finish: function(e) {
    var done = !this.state.done;
    ActivitiesListingActions.finishActivity(this.props.activityId, done);

    if(this.props.filters.pending||this.props.filters.finished&&!this.state.done){
      setTimeout(function(){
        ActivitiesListingActions.hideActivity(this.props.activityId);
      }.bind(this), 1000);
    } else if (this.props.filters.pending||this.props.filters.finished&&this.state.done) {
      setTimeout(function(){
        ActivitiesListingActions.hideActivity(this.props.activityId);
      }.bind(this), 300);
    }

  },
  render: function(){
    var classes = cx("activity-button", "btn-filter","activity-finishButton", ((!this.props.canFinish)?"disabled":""));
    var squareCheck = cx("finishButton-squareCheck", (this.state.done?"done":""),{"animate":this.state.shouldAnimate});
    var buttonLabel = cx("activity-finishButtonLabel",{"animate":this.state.shouldAnimate});

    if(!this.props.dueDate) {
      return null;
    } else {
      return (
        <span className="d-ib" title={this.getTitle()}>
          <button onClick={(this.props.canFinish)?this.finish:null} className={classes} ref="finishButton">
            <input ref="checkbox" readOnly checked={this.state.done} id="activity-finishButtonCheck1" className="activity-finishButtonCheck d-n" type="checkbox" />
            <label className={buttonLabel}>
              {(this.state.done)?"Finalizada":"Finalizar"}
            </label>

            <div className={squareCheck}></div>
          </button>
        </span>
      );
    }
  }
});

var ActivityRelatedObjects = React.createClass({
  getDefaultProps: function(){
    return {
      deal: {},
      person: {},
      organization: {}
    };
  },
  render: function(){
    var person = this.props.person;
    var organization = this.props.organization;

    if(this.props.deal&&this.props.deal.id){
      if(this.props.deal.organization) {
        organization = this.props.deal.organization;
      }
      else if(this.props.deal.person) {
        person = this.props.deal.person;
      }
    } else if(this.props.person&&this.props.person.id){
      if(this.props.person.organization) {
        organization = this.props.person.organization;
      }
    }

    return (
      <div className="activity-relatedTo d-f fs-14 minw-256">
        <ActivityRelatedObject objectType="deal" object={this.props.deal} filters={this.props.filters} />
        <ActivityRelatedObject objectType="person" object={person} filters={this.props.filters} />
        <ActivityRelatedObject objectType="organization" object={organization} filters={this.props.filters} />
      </div>
    );
  }
});

var ActivityRelatedObject = React.createClass({
  render: function(){
    var iconClasses = cx({
      "custom-glyphicon": true,
      "icon-deal": (this.props.objectType == "deal"),
      "icon-person": (this.props.objectType == "person"),
      "icon-organization": (this.props.objectType == "organization"),
      "ml-20": true,
      "va-mid": true
    });

    var filters = this.props.filters || {};
    var hoverObject = "pessoa";
    var objectId = this.props.object ? this.props.object.id : null;
    var objectName = this.props.object ? this.props.object.name : null;

    var isFilteredByObject = (filters.person_id || filters.organization_id || filters.deal_id);
    let multiObjectFilters = (filters.append_related_deals || filters.append_related_people);

    let isFilteredBySingleObject = isFilteredByObject && !multiObjectFilters

    if(this.props.objectType=="deal"){
      hoverObject = "negocio";
      objectName = this.props.object ? this.props.object.title : null;
    } else if(this.props.objectType=="organization"){
      hoverObject = "empresa";
    }

    var href = "/sistema/"+hoverObject+"s/historico.php?id="+objectId;

    return (objectId&&!isFilteredBySingleObject)?(
      <a className="activity-relatedObject truncate-sentence d-ib" href={href} data-hover-details={hoverObject} data-hover-id={objectId}>
        <span className={iconClasses}></span>
        <span className="va-mid">{objectName}</span>
      </a>
    ):null;
  }
});

module.exports = Activity;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activity.jsx